
import 'antd/dist/antd.css'
import React, {Component} from 'react';


import {  Card, DatePicker,Select} from 'antd';

import moment from 'moment'
//import './Svtoast.css'
import SVRAiport from '../../views/SVRAirport';
import FlyMciFormBusCom from '../sojourns/FlyMciFormBusCom'

import '../../views/AppTa.css'

import '../../css/SearchBar.css'
import SVRAirportDest from '../../views/SVRAirportDest';
const {  RangePicker } = DatePicker;
const { Option } = Select;

class FancySearchBarFat extends Component{

    onTripChange_Oneway_cosmos(dateMoment, sdate ){
        console.log(sdate)
        let fmd = dateMoment
        let fmo = fmd
       
        let moStartDate = moment(fmo)
        console.log(fmd)
      
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
      
        let start_date_s   = moStartDate.toISOString() 
        console.log("from**formatISO***", start_date_s)
  
        let f = this.state.filters
        let today_dt = new Date()
        f['startDate'] = !fmo ? today_dt :  fmo
       
        this.setState({filters:f} )
        this.props.setFilters(f)
        //this.saveFindState()
        

    }

    onTripChange_cosmos(dateMoment, sdate, tpdateMoment, tosdate ){
        console.log(sdate)
        let fmd = dateMoment
        let fmo = fmd[0]
        let tmo = fmd[1]
        let moEndDate = moment(tmo)
        let moStartDate = moment(fmo)
        console.log(fmd)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let end_date_s   = moEndDate.toISOString() 
        let start_date_s   = moStartDate.toISOString() 
        console.log("from**formatISO***", start_date_s)
        console.log("To**formatISO***", end_date_s)
        let f = this.state.filters
        let today_dt = new Date()
        f['startDate'] = !fmo ? today_dt :  fmo
        f['endDate'] = !tmo ? today_dt :  tmo
        this.setState({filters:f} )
        this.props.setFilters(f)
       // this.saveFindState()

    }
  
getCityTravelTypeView(qt, detmci, svsubmitparentmci){
    if(qt == 'multicity'){
        return(
            
                <FlyMciFormBusCom det={detmci}  svsubmitparentmci={svsubmitparentmci} onSubmit={svsubmitparentmci}></FlyMciFormBusCom>

                
              
        )


    }else{

   

    return (
        <div className="c-container-sbar">
                        <div className="c-box-flybar">
                            <span className="c-span">
                            <div>
        
                                <br />
                                <Card title="From"  bordered={false} style={{ width: 300 }}>
                                   {/*  
                                    <Search
                                        placeholder="From"
                                        onSearch={this.onSearchOrgtxt}
                                        style={{ width: 200 }}
                                        />
                                   */}
                                    <SVRAiport/>
                                   
                                    </Card>
                            </div>
                            
                            </span>
                        </div>
                        <div className="c-box-flybar">
                            <span className="c-span">
                            <div>
                                <br />
                                <Card title="ToFat" bordered={false} style={{ width: 300 }}>

                                    {/*
                                         <Search
                                        placeholder="To"
                                        onSearch={this.onSearchDesttxt}
                                        style={{ width: 200 }}
                                        />
                                    */}
                                    <SVRAirportDest></SVRAirportDest>
                                   
                                </Card>
                            </div>
                            
                            </span>
                        </div>
                        <div className="c-box-flybar">
                            <span className="c-span">
                            {this.getTripHtmlPicker(qt)}
                            
                            </span>
                        </div>

                       
                        <div className="c-box-flybar">
                                <span className="c-span">
                                <div>
                                <br />
                                <Card bordered={false}  style={{ width: 300 }}>
                            
                                    <button type="submit" className="btn btn-success" onClick={()=>this.flyAndImagesSVUsingQuery(this.state.filters)}>
                                        SearchFlightsSV
                                    </button> 
                                </Card>
                                </div>
                                </span>
                        </div>
                </div>
    )
  } 
}

    
    handleChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryTripType'] = !qText ? 'roundtrip' :  qText
        this.setState({filters:f} )
        this.props.setFilters(f)
        //this.saveFindState()
        /*
        const {endDate,startDate,
            esqueryText, esqueryDestText,
            esqueryChilds, esqueryInfants,esqueryAdults, 
            esqueryCabin,esqueryTripType } = f

        let moEndDate = moment(endDate)
        let moStartDate = moment(startDate)
        let mo_es = moEndDate.format('YYYY-MM-DD') 
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        let dest_init = 'aus'
        if(esqueryDestText){
            //will happen when we are arounfreip for onwaey it will be nul
            dest_init = esqueryDestText
        }
        let svfly_esquery_data = {
            my_orgqueryText: esqueryText.toLocaleUpperCase(),
           // my_dstqueryText: esqueryDestText.toLocaleUpperCase(),
            my_dstqueryText: dest_init.toLocaleUpperCase(),
            STARTDATE:mo_ss || "2025-11-25",
            ENDDATE: mo_es || "2025-11-27",
            DT_FORMAT: "%Y-%m-%d",
            time_zone: "Asia/Kolkata",
            esqueryChilds:(esqueryChilds ? esqueryChilds : "m0"),
            esqueryInfants:(esqueryInfants ? esqueryInfants : "i0"),
            esqueryAdults:(esqueryAdults ? esqueryAdults : "t1"),
            esqueryCabin:(esqueryCabin ? esqueryCabin : "ECONOMY"),
            esqueryTripType:(esqueryTripType ? esqueryTripType : "roundtrip"),
            svpageSize:5
        }
        
         let newfindData = { 'svfly_esquery_data' : svfly_esquery_data}
        this.props.saveFindEsQueryDataSuccess(newfindData)

        */
    }

    handleTravellerChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryAdults'] = !qText ? 't1' :  qText
        this.setState({filters:f} )
        this.props.setFilters(f)
        //this.saveFindState()

    }
    handleCabinChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryCabin'] = !qText ? ["ECONOMY"] :  qText
        this.setState({filters:f} )
        this.props.setFilters(f)
       // this.saveFindState()


    }
    handleChildChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryChilds'] = !qText ? 'm1' :  qText
        this.setState({filters:f} )
        this.props.setFilters(f)
       // this.saveFindState()


    }

    handleInfantChange(qText){
        console.log(`selected ${qText}`);
        let f = this.state.filters
        f['esqueryInfants'] = !qText ? 'i0' :  qText
        this.setState({filters:f} )
       // this.saveFindState()


    }
    constructor(props) {
        super(props)
        this.getTripHtmlPicker = this.getTripHtmlPicker.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onSearchOrgtxt = this.onSearchOrgtxt.bind(this)
        this.onSearchDesttxt = this.onSearchDesttxt.bind(this)
        
        this.handleTravellerChange = this.handleTravellerChange.bind(this)
        this.handleChildChange = this.handleChildChange.bind(this)
        this.handleCabinChange = this.handleCabinChange.bind(this)
        this.getCityTravelTypeView = this.getCityTravelTypeView.bind(this)
        
        this.onTripChange_cosmos = this.onTripChange_cosmos.bind(this)
        this.onTripChange_Oneway_cosmos = this.onTripChange_Oneway_cosmos.bind(this)
        
       
        
        
        this.state = { 
            value: '', 
            inputValueds:'',
            //inputValue:'react',
            selectedOptionds: '',
            inputValue:'react',
           
            //inputValue:'react',
            selectedOption: { label: "react", value: "3" },
            dataSource:[
                { label: "hello", value: "1" },
                { label: "codesandbox", value: "2" },
                { label: "react", value: "3" },
                { label: "nodejs", value: "4" },
                { label: "java", value: "5" },
                { label: "antd", value: "6" },
                { label: "dependency", value: "7" },
                { label: "less", value: "8" }
              ],
            /*
            svstate : {
                startDate: new Date(),
                endDate: new Date(),
           
            key: 'selection'
            },  
            */
            ids: ['APP_OPERATIONAL_STATUS', 'DV_U_SERVICE_ASG', 'DV_U_SERVICE_NAME', 'DV_U_SERVICE_OFFERING', 'APPLICATION_NAME'],
            labels: ['Status', 'Service ASG', 'Service Name', 'Service Offering', 'Application'],
            filters: {
                
                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
               // "endDate": "2024-07-22T25:42:55.795+00:00" ,
               startDate : new Date(),
               endDate : new Date(),
               esqueryAdults:"t1",
               esqueryChilds:"m1",
               esqueryInfants:"i0",
               esqueryCabin:"ECONOMY",
               esqueryTripType:"roundtrip",
               
               esqueryText: '',
               esqueryDestText: '',
               dataSourceSV : ['Burns Bay Road', 'Downing Street', 'Wall Street'],
            
              
                key: 'selection',
                "hotelsSelected":{"value": "kenServer", "label": "kenServer"},
                hotels: {
                    
                    options:[
                        { value: 'jen', label: 'jen1Server' },
                        { value: 'ken', label: 'ken1Server' },
                        { value: 'ben', label: 'ben1Server' }
                    ],
                    values: { value: 'ken', label: 'ken1Server' }
            },
                HOTEL_DEST: {
                    id: "HOTEL_DEST_STATUS", 
                    defaultOptions: [], 
                    options: [],
                    label: "Hptel Location",
                    values: [],
                    showing: []

                },
                HOTEL_DATE_RANGE: {
                   
                        startDate: new Date(),
                        endDate: new Date(),
                   
                    key: 'selection'
                    
                },
                APP_OPERATIONAL_STATUS:{
                    id: "APP_OPERATIONAL_STATUS", 
                    defaultOptions: [], 
                    options: [],
                    label: "Status",
                    values: [],
                    showing: []
                },
                
                APPLICATION_NAME: {
                    id: "APPLICATION_NAME",
                    defaultOptions: [],
                    options: [],
                    label: "Applications",
                    values: [],
                    showing: []
                }
              
            }
        }
    }
     getTripHtmlPicker(qt){
       
        if(qt == 'onewaytrip'){
           

            return (
                
                <div>
                                <br />
                                <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}>
                                    <DatePicker onChange={this.onTripChange_Oneway_cosmos}   />
                                </Card>
                </div>

            )
            
        }else if(qt == 'roundtrip'){ 
            return (
                
                <div>
                                <br />
                                <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}>
                                    <RangePicker onChange={this.onTripChange_cosmos} />
                                </Card>
                </div>

            )
            
        }else{

            return (
                
                <div>
                                <br />
                                <Card title="Travel Departure - Return" bordered={false} style={{ width: 300 }}>
                                    <RangePicker  onChange={this.onTripChange_cosmos} />
                                </Card>
                </div>

            )
        }
        
    }
    
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        const {filters } = this.props
        if(this.filters){
            this.setState({filters:this.props.filters})
        }else{
            console.log('cwn didnot get filters')
        }
       
        //this.loadDDValuesFromServer()
        //console.log(this.props.params)
    }


    onSearchOrgtxt = qText => {
        
        let f = this.state.filters
       
     
        f['esqueryText'] = !qText ? [] :  qText
        this.setState({filters:f} )
        //this.saveFindState()
        
      };
      onSearchDesttxt = qText => {
    
        let f = this.state.filters
       
     
        f['esqueryDestText'] = !qText ? [] :  qText
        this.setState({filters:f} )
        //this.saveFindState()
        
      };
    render(){
        let qt = 'roundtrip'
        console.log('SV**Apr7 *** state esqueryTripType*** start')
        console.log(this.props)

        let detmci = {
            "id": "addLeft_step",
            "testlastName": "svlondonKW",
            "gene":"svgene",
           
            "members": [
                {
                    "tid": 1,
                    "my_orgqueryText": "JFK",
                    "my_dstqueryText": "LAX",
                    "STARTDATE":"2024-12-03",
                    "DT_FORMAT": "%Y-%m-%d",
                    "time_zone": "Asia/Kolkata"
                   
                },
                {
                    "tid": 2,
                    "my_orgqueryText": "LAX",
                    "my_dstqueryText": "SFO",
                    "STARTDATE":"2024-12-07",
                    "DT_FORMAT": "%Y-%m-%d",
                    "time_zone": "Asia/Kolkata"
                   
                },
                {
                    "tid": 3,
                    "my_orgqueryText": "SFO",
                    "my_dstqueryText": "JFK",
                    "STARTDATE":"2024-12-17",
                    "DT_FORMAT": "%Y-%m-%d",
                    "time_zone": "Asia/Kolkata"
                   
                }
            ],
               "gender": "MALE"
        }
        return (
            <div>
                <div className="searchBar">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="c-container-profilebar">
                                    <div className="c-box-profilebar">
                                        <span className="c-span">
                                            <Select defaultValue="roundtrip" style={{ width: 120 }} onChange={this.handleChange}>
                                            <Option value="roundtrip">Round Trip</Option>
                                            <Option value="onewaytrip">One Way</Option>
                                            <Option value="multicity" >
                                                Multi City
                                            </Option>
                                            <Option value="Yiminghe" disabled>yiminghe</Option>
                                            </Select>
                                        </span>
                                    </div> 
                                    <div className="c-box-profilebar">
                                        <span className="c-span">
                                        <Select defaultValue="t1" style={{ width: 120 }}  >
                                        <Option value="t1">1 Adult</Option>
                                        <Option value="t2">2 Adult</Option>
                                        <Option value="t3">3 Adult</Option>
                                        <Option value="t4">4 Adult</Option>
                                        <Option value="t5">5 Adult</Option>
                                        <Option value="t6">6 Adult</Option>
                                        
                                        </Select>
                                        </span>
                            </div>
                            <div className="c-box-profilebar">
                                        <span className="c-span">
                                        <Select defaultValue="m0" style={{ width: 120 }} onChange={this.handleChildChange}>
                                        <Option value="m0">No Child</Option>
                                        <Option value="m1">1 Child</Option>
                                        <Option value="m2">2 Child</Option>
                                        
                                        </Select>
                                        </span>
                            </div>
                            <div className="c-box-profilebar">
                                        <span className="c-span">
                                        <Select defaultValue="ECONOMY" style={{ width: 120 }} onChange={this.handleCabinChange}>
                                        <Option value="c0">Show All </Option>
                                        <Option value="ECONOMY">Basic Economy</Option>
                            
                
                                        <Option value="PREMIUM_ECONOMY">Premium Economy</Option>
                                        <Option value="BUSINESS">Business</Option>
                                        <Option value="FIRST">First</Option>
                                        
                                        </Select>
                                        </span>
                            </div>
                                </div>
                                <div className="c-container-sbar">
                                                    <div className="c-box-flybar">
                                                        <span className="c-span">
                                                        <div>
                                    
                                                            <br />
                                                            <Card title="From"  bordered={false} style={{ width: 300 }}>
                                                            
                                                            <SVRAiport/>
                                                                </Card>
                                                        </div>
                                                        
                                                        </span>
                                                    </div>
                                                    <div className="c-box-flybar">
                                                        <span className="c-span">
                                                        <div>
                                                            <br />
                                                            <Card title="ToFancy" bordered={false} style={{ width: 300 }}>
                                                            <SVRAirportDest></SVRAirportDest>
                                                            </Card>
                                                        </div>
                                                        
                                                        </span>
                                                    </div>
                                                    <div className="c-box-flybar">
                                                        <span className="c-span">
                                                        {this.getTripHtmlPicker(qt)}
                                                        
                                                        </span>
                                                    </div>
                                                    <div className="c-box-flybar">
                                            <span className="c-span">
                                            <div>
                                            <br />
                                            <Card bordered={false}  style={{ width: 300 }}>
                                        
                                                <button type="submit" className="btn btn-success" >
                                                    SearchFlightsSV
                                                </button> 
                                            </Card>
                                            </div>
                                            </span>
                                    </div>
                            
                                </div>
                            </div>
                        </div>
                </div>
            </div>
                );
    }

}

export default FancySearchBarFat